import Control from "../../../../../../common/Controls/Control";
import RCPROPrestationsInternationales from "./RCPROPrestationsInternationales";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROInformatique = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig, formState } =
    useRCPROQuestion({ company });

  const activityKey = "informatique";

  return (
    <div>
      <Control
        label={inputsConfig.informatiqueActivitePrincipale.label}
        type="checkBtnList"
        name="informatiqueActivitePrincipale"
        value={company.RCPRO.informatiqueActivitePrincipale}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.informatiqueActivitePrincipale.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
        info={<>Plusieurs réponses possibles</>}
      />
      <Control
        label={inputsConfig.informatiqueInterventionCritique.label}
        type="btnList"
        name="informatiqueInterventionCritique"
        value={company.RCPRO.informatiqueInterventionCritique}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.informatiqueInterventionCritique.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      <RCPROPrestationsInternationales
        company={company}
        activityKey={activityKey}
      />
    </div>
  );
};

export default RCPROInformatique;
